import request from '@/utils/httpClient'
import { PersonnelCommissionStatRequest, PersonnelCommissionSummary } from '@/types/domain'

/**
 * 获取人员业务提成汇总统计
 */
export function getPersonnelCommissionSummary(params?: PersonnelCommissionStatRequest): Promise<PersonnelCommissionSummary[]> {
  return request({
    url: 'stat/personnel-commission',
    method: 'get',
    params
  })
}
